module.exports = __webpack_public_path__ + "static/media/arrow-svgrepo-com (3).866bf31d.svg";